export const useLayout = () =>
  useState<{ showHeader: boolean; showFooter: boolean }>('layout', () => ({
    showHeader: true,
    showFooter: true,
  }));
